<template>
  <div class="pageContent">
    <el-form size="small" label-width="140px">
      <el-form-item label="规则类型">
        <el-radio-group v-model="formData.type" @change="radioClick">
          <el-radio :label="1">充值</el-radio>
          <el-radio :label="2">加油</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="油品选择" v-if="formData.type == 2">
        <el-checkbox-group v-model="formData.goods_id">
          <el-checkbox v-for="n in oilsList" :key="n.id" :label="n.id">{{
            n.name
          }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="规则名称">
        <el-input v-model="formData.name" class="form_input"></el-input>
      </el-form-item>
      <el-form-item label="适用门店">
        <el-select v-model="formData.room_id" @change="Select">
          <el-option
            v-for="item in roomList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="买单规则" v-if="formData.type == 2">
        <div>
          <el-form class="form_item" size="small" label-width="auto">
            <el-form-item label="提成规则">
              <el-radio-group v-model="formData.rule_type">
                <el-radio :label="1">按照每单提成计算</el-radio>
                <el-radio :label="2">按照总金额提成计算</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="计算方式">
              <el-radio-group v-model="formData.rule_unit">
                <el-radio :label="1">按照金额计算</el-radio>
                <el-radio :label="2">按照升数计算</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="计算比例">
              <el-radio-group v-model="formData.rule_rate">
                <el-radio :label="1">元</el-radio>
                <el-radio :label="2">百分比</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="提成细则">
              <el-button size="small" type="primary" @click="addNumRule(1)"
                >添加提成细则</el-button
              >
              <div
                class="rule_item"
                v-for="(rule, idx) in orderList"
                :key="idx"
              >
                <span>销售</span>
                <el-input
                  class="roy-item"
                  v-model="rule.start"
                  @change="startInput"
                >
                  <template slot="append">{{
                    formData.rule_unit == 2 ? "升" : "元"
                  }}</template>
                </el-input>
                <span>至</span>
                <el-input
                  class="roy-item"
                  v-model="rule.end"
                  @change="endInput"
                >
                  <template slot="append">{{
                    formData.rule_unit == 2 ? "升" : "元"
                  }}</template>
                </el-input>
                <span>可提成</span>
                <el-input class="roy-item" v-model="rule.rate">
                  <template slot="append">{{
                    formData.rule_rate == 2 ? "%" : "元"
                  }}</template>
                </el-input>
                <span>最高提成</span>
                <el-input class="roy-item" v-model="rule.max">
                  <template slot="append">
                    元
                  </template>
                </el-input>
                <span
                  ><el-button
                    size="small"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click="delNumRule(1, idx)"
                  ></el-button
                ></span>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-form-item>
      <el-form-item label="充值规则" v-if="formData.type == 1">
        <div>
          <el-form class="form_item" size="small" label-width="auto">
            <el-form-item label="提成规则类型">
              <el-radio v-model="formData.rule_type" :label="1"
                >按照每单提成计算</el-radio
              >
              <el-radio v-model="formData.rule_type" :label="2"
                >按照总金额提成计算</el-radio
              >
            </el-form-item>
            <el-form-item label="计算比例">
              <el-radio v-model="formData.rule_rate" :label="1">元</el-radio>
              <el-radio v-model="formData.rule_rate" :label="2"
                >百分比</el-radio
              >
            </el-form-item>
            <el-form-item label="提成细则">
              <el-button size="small" type="primary" @click="addNumRule(2)"
                >添加提成细则</el-button
              >
              <div
                class="rule_item"
                v-for="(rule, idx) in voucherList"
                :key="idx"
              >
                <span>充值</span>
                <el-input
                  class="roy-item"
                  v-model="rule.start"
                  @change="startInput"
                >
                  <template slot="append">
                    {{ formData.rule_unit == 2 ? "升" : "元" }}
                  </template>
                </el-input>
                <span>至</span>
                <el-input
                  class="roy-item"
                  v-model="rule.end"
                  @change="endInput"
                >
                  <template slot="append">
                    {{ formData.rule_unit == 2 ? "升" : "元" }}
                  </template>
                </el-input>
                <span>可提成</span>
                <el-input class="roy-item" v-model="rule.rate">
                  <template slot="append">
                    {{ formData.rule_rate == 2 ? "%" : "元" }}
                  </template>
                </el-input>
                <span>最高提成</span>
                <el-input class="roy-item" v-model="rule.max">
                  <template slot="append">
                    元
                  </template>
                </el-input>
                <span
                  ><el-button
                    size="small"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click="delNumRule(2, idx)"
                  ></el-button
                ></span>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-form-item>
      <el-form-item label="选择员工">
        <el-select
          v-model="formData.employee_id"
          multiple
          collapse-tags
          placeholder="请选择"
        >
          <el-option
            v-for="item in staffData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div class="bottom_button">
      <el-button @click="goBack()">返 回</el-button>
      <el-button type="primary" @click="save()">保 存</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commissionAdd, commissionDetail, commissionEdit, employeeList, storeSelect } from "@/api/employee.js";
import { goodsOptions, listRefule } from "@/api/vip.js";
import { cardList } from "@/api/motorcade.js";
import { listAssign } from "@/utils/public";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      formData: {
        type: 1,
        rule_unit: 1,
        goods_id: [],
        rule: [],
        employee_id: [],
        name: "",
        room_id: "",
        rule_type: 1,
        rule_rate: 1
      }, // 表单数据
      oilsList: [], // 全部油品列表
      roomList: [], // 门店列表
      orderList: [{ start: "", end: "", rate: "", max: "" }], // 加油规则列表
      voucherList: [{ start: "", end: "", rate: "", max: "" }], // 充值规则列表
      staffData: [] //员工
    };
  },
  mounted() {
    this.init();
  },
  watch: {},
  methods: {
    radioClick(e){
      if(e == 2){
        this.formData.goods_id = []
      }
    },
    init() {
      var data = {
        app_id: this.app_id
      };
      storeSelect(data).then(res => {
        if (res.code == 200) {
          this.roomList = res.data;
        }
      });
      this.emp();
      listRefule(data).then(res => {
        if (res.code == 200) {
          this.oilsCardList = res.result;
        }
      });
      cardList(data).then(res => {
        if (res.code == 200) {
          this.teamCardList = res.result;
        }
      });
      goodsOptions(data).then(res => {
        if (res.code == 200) {
          this.oilsList = res.data;
          console.log("youpin", this.oilsList);
        }
      });
      if (this.$route.query.id) {
        commissionDetail({
          app_id: this.app_id,
          id: this.$route.query.id
        }).then(res => {
          if (res.code == 200) {
            this.emp(res.data.room_id);
            this.$nextTick(() => {
              listAssign(this.formData, res.data);
              listAssign(this.formData, res.data.item);
              this.formData.employee_id = res.data.item.employee_id.split(",");
              this.formData.employee_id.forEach((item, i) => {
                this.formData.employee_id[i] = item!=''&&item!=0?Number(item):'';
              });
              if (res.data.type == 1) {
                this.voucherList = res.data.item.rule;
              } else {
                this.orderList = res.data.item.rule;
                this.formData.goods_id = res.data.item.goods_id.split(",");
                console.log('1',this.formData.goods_id)
                this.formData.goods_id.forEach((item, i) => {
                  this.formData.goods_id[i] = item!=''&&item!=0?Number(item):'';
                });
              }
            });
          } else {
            this.$message(res.msg);
          }
        });
      }
    },
    //监听开始值到结束值的范围
    startInput(val) {
      console.log(val);
      if (this.formData.type == 1) {
        if (this.voucherList.length > 1) {
          for (let i = 0; i < this.voucherList.length; i++) {
            if (Number(val) < Number(this.voucherList[i].end)) {
              if (this.voucherList[i + 1]) {
                this.voucherList[i + 1].start =
                  Number(this.voucherList[i].end) + 1;
              }
            }
          }
        }
      } else {
        if (this.orderList.length > 1) {
          for (let i = 0; i < this.orderList.length; i++) {
            if (Number(val) < Number(this.orderList[i].end)) {
              if (this.orderList[i + 1]) {
                this.orderList[i + 1].start = Number(this.orderList[i].end) + 1;
              }
            }
          }
        }
      }
    },
    endInput(val) {
      console.log(val);
      if (this.formData.type == 1) {
        for (let i = 0; i < this.voucherList.length; i++) {
          if (Number(val) <= Number(this.voucherList[i].start)) {
            this.voucherList[i].end = Number(this.voucherList[i].start) + 1;
          }
        }
      } else {
        for (let i = 0; i < this.orderList.length; i++) {
          if (Number(val) <= Number(this.orderList[i].start)) {
            this.orderList[i].end = Number(this.orderList[i].start) + 1;
          }
        }
      }
    },
    //员工
    emp(id) {
      let data = {
        app_id: this.app_id,
        room_id: id
      };
      employeeList(data).then(res => {
        this.staffData = res.data;
      });
    },

    //选择门店
    Select(val) {
      console.log(val);
      this.formData.employee_id = [];
      this.emp(val);
    },
    // 添加提成细则
    addNumRule(type) {
      console.log(this.formData.rule);
      if (type == 1) {
        this.orderList.push({ start: "", end: "", rate: "", max: "" });
      } else {
        this.voucherList.push({ start: "", end: "", rate: "", max: "" });
      }
    },
    // 删除提成细则
    delNumRule(type, i) {
      if (type == 1) {
        this.orderList.splice(i, 1);
      } else {
        this.voucherList.splice(i, 1);
      }
    },
    // 保存
    save() {
      let data = {
        ...this.formData,
        app_id: this.app_id
      };
      data.employee_id = this.formData.employee_id.join(",");
      if(this.formData.type == 2){
        console.log(this.formData.goods_id)
        data.goods_id = this.formData.goods_id.join(",");
      }
      if (this.formData.type == 1) {
        data.rule = this.voucherList;
      } else {
        data.rule = this.orderList;
      }
      if (this.$route.query.id) {
        data.id = this.$route.query.id;
        commissionEdit(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.$router.go(-1);
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        commissionAdd(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.$router.go(-1);
          } else {
            this.$message.error(res.msg);
          }
        });
      }

      console.log("dddddd", data);
    },
    // 返回
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.pageContent {
  border: 20px solid #f1f2f6;
  padding: 40px 20px 10px 20px;
  height: 100%;
  overflow: auto;
  .options {
    line-height: 79px;
  }
  .table_box {
    margin-bottom: 20px;
  }
  .form_input {
    width: 340px;
  }
  .rule_item {
    line-height: 30px;
    margin-top: 15px;
    span {
      display: inline-block;
    }
    .roy-item {
      width: 140px;
      margin: 0 10px;
    }
  }
  .form_item {
    padding-bottom: 5px;
    margin-bottom: 15px;
    // border-bottom: 1px dashed #aaa;
  }
  .form_checkbox_line {
    margin-top: 5px;
  }
}
.bottom_button {
  margin: 0 -20px;
  margin-top: 30px;
  line-height: 60px;
  text-align: center;
  // border-top: 10px solid #f1f2f6;
}
</style>
